const SESSION_ID_KEY = 'bookmyfresh_guest_session_id';

const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};

export const getSessionId = () => {
  let sessionId = localStorage.getItem(SESSION_ID_KEY);
  if (!sessionId) {
    sessionId = generateUUID();
    localStorage.setItem(SESSION_ID_KEY, sessionId);
  }
  return sessionId;
};

export const clearSessionId = () => {
  localStorage.removeItem(SESSION_ID_KEY);
};

export const hasSessionId = () => {
  return !!localStorage.getItem(SESSION_ID_KEY);
};

export default { getSessionId, clearSessionId, hasSessionId };